export default __webpack_public_path__ + "static/media/img5_1.1ae66aee.jpg";